import { render } from "./LyricsLoveOfGod.vue?vue&type=template&id=633d3b32&scoped=true"
import script from "./LyricsLoveOfGod.vue?vue&type=script&lang=js"
export * from "./LyricsLoveOfGod.vue?vue&type=script&lang=js"

import "./LyricsLoveOfGod.vue?vue&type=style&index=0&id=633d3b32&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633d3b32"]])

export default __exports__